<div class="content-section p-0">
    <div class="">
        <div class="alert alert-warning mt-2" role="alert" *ngIf="!isInstitutionConfigured">
            {{ 'CONFIGURE.NOT_CONFIGURED_REFERENCE_CONFIGURATION.WARD' | translate }}
        </div>

        <div class="container-page pl-0 pr-0" >
            <div class="filter-box mb-4 w-25">
                <button *ngFor="let filter of filters" class="filter-button"
                    [ngClass]="{'filter-button-selected': filterType == filter.value, 'disabled': isFilterDisabled && filter.value != 'progress'}"
                    (click)="onClickFilter(filter.value)">
                    {{ filter.name | translate }} ({{ checkListCounts[filter.value] }})
                </button>
            </div>
            <div *ngIf="checkList.checkList.length > 0">
                <lib-audit-card 
                    *ngFor="let check of checkList.checkList; let i = index" 
                    [check]="check" 
                    [position]="i" 
                    (updateCheckListEvent)="reloadCheckList()"></lib-audit-card>
        
                <lib-pagination
                    [page]="page"
                    [totalPages]="checkList.totalPages"
                    [listLength]="checkList.checkList.length"
                    [totalItems]="checkList.totalChecks"
                    (changePageEvent)="goToPage($event)"
                ></lib-pagination>
            </div>
        </div>
    
        <div class="container-page check-not-found-container" *ngIf="checkList.checkList.length === 0">
            <div class="check-not-found" > 
                <img class="icon" src="assets/icons/questionAnswerOutlined.svg" />
                <span class="info-message"> {{ 'CHECK.NO_RECORDS_FOUND' | translate }} </span>
            
                <button type="button" class="btn btn-square-responsive" [disabled]="!isInstitutionConfigured" (click)="navigateTo()">
                    <img src="assets/icons/plusOutlined.svg" />
                    <span>{{ 'CHECK.NEW_HYGIENE_CHECK_TITLE' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</div>

<lib-delete-modal></lib-delete-modal>
<lib-download-modal></lib-download-modal>